import { render, staticRenderFns } from "./HistoryProduct.vue?vue&type=template&id=a5ef5fe8"
import script from "./HistoryProduct.vue?vue&type=script&lang=js"
export * from "./HistoryProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports